import { useAtom } from 'jotai';
import { selectedSiteAtom } from './useSite';

export function useSelectedSite() {
  const [selectedSite] = useAtom(selectedSiteAtom);
  return { selectedSite };
}
